export default "__VITE_ASSET__DBGVxWu9__"